import { render, staticRenderFns } from "./SchoolRegistration.vue?vue&type=template&id=948ab686"
import script from "./SchoolRegistration.vue?vue&type=script&lang=js"
export * from "./SchoolRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports